import { useState } from 'react';
import { priceWithCommas } from '../utils/commonHelper';
import t from './locales';

const PeopleCountSelector = ({ options, locale, localCurrency, defaultCheck }) => {
  const [selectedOption, setSelectedOption] = useState(defaultCheck || options[0].value);

  const priceArray = options

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <div>
      {priceArray.map(option => (option.price > 0 || process.env.RAILS_ENV === 'staging' || process.env.RAILS_ENV === 'development') && (
        <div key={option.value} className='radio-item d-flex align-items-center'>
          <input
            type='radio'
            id={`order_group[orders_attributes][0][${option.value}_num]`}
            name='order_group[orders_attributes][0][season_pass_person_type]'
            value={option.value}
            checked={selectedOption === option.value}
            onChange={handleOptionChange}
            className='custom-radio-button people-count-selector__counter__value'
          />
          <label htmlFor={`order_group[orders_attributes][0][${option.value}_num]`} className="snow-item__price__label people-count-selector__price-info__num-name ml-1 mt-2" style={{ fontSize: '1.1em' }}>
            {t[`${option.label}`]()}
          </label>
          <div className='people-count-selector__price-info__price'>
            <span className='people-count-selector__price-info__price--discounted price ml-auto'>
              {locale === 'ja'
                ? `${priceWithCommas(option.price)}円`
                : `${localCurrency.code} ${priceWithCommas(option.localizePrice)}`}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PeopleCountSelector;
